// extracted by mini-css-extract-plugin
module.exports = {"alert":"Alert_alert__3wWCU","text":"Alert_text__3YELO"};